let fallbackCounter = 0;

function encodeHex(bytes: Uint8Array) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

/** UI/Fake identifiers only. The time/counter fallback is not secure randomness. */
export function createRandomId(prefix?: string): string {
  const crypto = globalThis.crypto;
  let id: string;
  if (typeof crypto?.randomUUID === 'function') {
    id = crypto.randomUUID();
  } else if (typeof crypto?.getRandomValues === 'function') {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = encodeHex(bytes);
    id = [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20),
    ].join('-');
  } else {
    fallbackCounter += 1;
    id = `fallback-${Date.now().toString(36)}-${fallbackCounter.toString(36)}`;
  }
  return prefix ? `${prefix}-${id}` : id;
}

/** Tokens must have secure randomness, including in HTTP-hosted Fake demos. */
export function createSecureRandomToken(byteLength = 32): string {
  if (!Number.isSafeInteger(byteLength) || byteLength <= 0) {
    throw new RangeError('Token byte length must be a positive integer.');
  }
  const crypto = globalThis.crypto;
  if (typeof crypto?.getRandomValues !== 'function') {
    throw new Error('Secure randomness is unavailable.');
  }
  return encodeHex(crypto.getRandomValues(new Uint8Array(Math.max(32, byteLength))));
}
